import { createAsyncThunk } from '@reduxjs/toolkit';
import { push } from 'redux-first-history';

import { showLoading, hideLoading } from '../app';
import { ROUTES } from '../../helpers/constants';
import ManagementAPIClient from '../../api/management';

const authenticateManagementUser = createAsyncThunk(
  'management/authenticateManagementUser',
  async (_, { dispatch }) => {
    try {
      dispatch(showLoading());
      return { user: [], memberships: [] };
    } catch (err) {
      console.error('Authentication Error: ', err);
      dispatch(push(ROUTES.LANDING.path));
    } finally {
      dispatch(hideLoading());
    }
  }
);

const getManagementOrganizations = createAsyncThunk(
  'management/getManagementOrganizations',
  async (_, { dispatch }) => {
    try {
      dispatch(showLoading());
      const items = await new ManagementAPIClient().GET('/admin/organizations');
      const organizations = (items ?? []).map((org) => ({
        org_id: org.item_id,
        name: org.name,
      }));
      return { organizations };
    } catch (err) {
      console.error('Management Org Fetch Error: ', err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

const getManagementUsers = createAsyncThunk(
  'management/getManagementUsers',
  async (_, { dispatch }) => {
    try {
      dispatch(showLoading());
      const items = await new ManagementAPIClient().GET('/users');
      const users = (items ?? []).map((u) => ({
        user_id: u.item_id,
        name: u.name,
        email: u.email,
      }));
      return { users };
    } catch (err) {
      console.error('Management Users Fetch Error: ', err);
    } finally {
      dispatch(hideLoading());
    }
  }
);

export { authenticateManagementUser, getManagementOrganizations, getManagementUsers };